import { Platform, Orientation, DeviceType, IModuleSwiperItem } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import styled from 'styled-components';

type Attributes = {
	deviceType: DeviceType;
	orientation: Orientation;
	platform: Platform;
	hasArmrestPicker: boolean;
	isSafari: boolean;
	moduleItems: Array<IModuleSwiperItem>;
	isScrollable: boolean;
};

function getButtonStyle(props: Attributes): string {
	return `
		#iconButton {
			position: ${
				!props.isScrollable
					? 'absolute'
					: (props.deviceType === 'mobile' && props.orientation === 'portrait') ||
					  props.deviceType === 'tablet'
					? 'fixed'
					: 'sticky'
			};
			left: ${!props.isScrollable ? 'calc(50% - 20px)' : ''};
			bottom: ${
				(props.deviceType === 'mobile' && props.orientation === 'portrait') ||
				props.deviceType === 'tablet'
					? 'auto'
					: props.deviceType === 'mobile' && props.orientation === 'landscape'
					? '4px'
					: '0'
			};
			width: auto;
			z-index: 3;
			display: flex;
			justify-content: ${
				(props.deviceType === 'mobile' && props.orientation === 'portrait') ||
				props.deviceType === 'tablet'
					? 'normal'
					: 'center'
			};
		}

		#iconButton:first-child {
			position: ${
				(props.deviceType === 'mobile' && props.orientation === 'portrait') ||
				props.deviceType === 'tablet'
					? 'fixed'
					: 'sticky'
			};
			left: initial;
			top: ${
				(props.deviceType === 'mobile' && props.orientation === 'portrait') ||
				props.deviceType === 'tablet'
					? 'auto'
					: props.deviceType === 'mobile' && props.orientation === 'landscape'
					? '4px'
					: '0'
			};
			z-index: 3;
			width: auto;
		}
	`;
}

function getModuleSwiperLayout(props: Attributes): string {
	if (props.platform === 'kiosk') {
		return `
			display: block;
			align-items: normal;
			flex-direction: column;
			width: 435px;
			height: ${props.hasArmrestPicker ? 'calc(100% - 248px)' : 'calc(100% - 122px)'};
			overflow-y: scroll;
			overflow-x: hidden;
			::-webkit-scrollbar {
				width: 3px;
			}
			::-webkit-scrollbar-track {
				background: ${SkapaTheme.color.neutral.grey200};
				border-radius: 4px;
			}
			::-webkit-scrollbar-thumb {
				background: ${SkapaTheme.color.neutral.grey900};
				border-radius: 4px;
			}
		`;
	}

	switch (props.deviceType) {
		case 'mobile':
			return `
				display: ${props.orientation === 'landscape' ? 'block' : 'flex'};
				align-items: center;
				white-space: nowrap;
				overflow-y: ${props.orientation === 'landscape' ? 'auto' : 'hidden'};
				overflow-x: ${props.orientation === 'landscape' ? 'hidden' : 'auto'};
				::-webkit-scrollbar {
					display: none;
					scrollbar-width: none;
				}
			`;
		case 'tablet':
			return `
				display: flex;
				flex: 1 1 auto;
				align-items: center;
				max-height: none;
				max-width: calc(100% - 60px);
				overflow-y: hidden;
				overflow-x: auto;
				white-space: nowrap;
				::-webkit-scrollbar {
					display: none;
					scrollbar-width: none;
				}
			`;
		default:
			return `
				padding: 0 ${SkapaTheme.spacing.space50}px;
				display: block;
				align-items: normal;
				flex-direction: column;
				height: ${
					props.hasArmrestPicker
						? props.isSafari
							? 'calc(100% - 149px)'
							: 'calc(100% - 145px)'
						: '100%'
				};

				position: relative;
				overflow-y: scroll;
				overflow-x: hidden;
				width: 320px;
				::-webkit-scrollbar {
					width: 3px;
				}
				::-webkit-scrollbar-track {
					background: ${SkapaTheme.color.neutral.grey200};
					border-radius: 4px;
				}
				::-webkit-scrollbar-thumb {
					background: ${SkapaTheme.color.neutral.grey900};
					border-radius: 4px;
				}
			`;
	}
}

function getDefaultStyle(): string {
	return `
		background-color: ${SkapaTheme.color.neutral.white};
		outline: none;
		position: relative;
	`;
}

export const Div = styled.div<Attributes>`
	${getDefaultStyle()};
	${(props): string => getModuleSwiperLayout(props)};
	${(props): string => getButtonStyle(props)};
`;
